import React from 'react'
import './index.css'







const Table = () => {
    return ( 
        <div className='md:mx-20 my-6 overflow-x-auto '>
           



<html>

<body>



<table>




<tr>

<th colSpan='9'>CIVIL DIMENSIONS FOR JHANSI ELECTRA ELEVATOR</th>

</tr>

  <tr style={{backgroundColor:'#b4d6d9'}}>
    <td colSpan={2}>CAPACITY	</td>
    <td colSpan={2}>CAR INSIDE	</td>
    <td colSpan={2}>LIFT WELL	</td>   
    <td>ENTRANCE</td>

 
  </tr>


  <tr>
   
    <td>PERSONS</td>
    <td>LOAD/KGS</td>
    <td>WIDTH</td>
    <td>DEPTH</td>
    <td>WIDTH</td>
    <td>DEPTH</td>
    <td></td>
    
  

  </tr>

  <tr>
   
   <td></td>
   <td></td>
   <td>1100</td>
   <td>1000</td>
   <td>1550</td>
   <td>1600</td>
   <td>700(min)</td>
   
 

 </tr>





  <tr>
   
   <td>6</td>
   <td>408</td>
   <td>1200</td>
   <td>900</td>
   <td>1750</td>
   <td>1500</td>
   <td>800</td>
   
 

 </tr>


 <tr>
   
   <td></td>
   <td></td>
   <td>1300</td>
   <td>1100</td>
   <td>1750</td>
   <td>1700</td>
   <td>800</td>
   
 

 </tr>



 <tr>
   
   <td>8</td>
   <td>544</td>
   <td>1400</td>
   <td>1000</td>
   <td>1800</td>
   <td>1600</td>
   <td>800</td>
   
 

 </tr>

 <tr>
   
   <td></td>
   <td></td>
   <td>1300</td>
   <td>1350</td>
   <td>1750</td>
   <td>1950</td>
   <td>800</td>
   
 

 </tr>

 <tr>
   
   <td>10</td>
   <td>680</td>
   <td>1400</td>
   <td>1250</td>
   <td>1800</td>
   <td>1850</td>
   <td>800</td>
   
 

 </tr>

 <tr>
   
   <td>13</td>
   <td>884</td>
   <td>2000</td>
   <td>1100</td>
   <td>2450</td>
   <td>1700</td>
   <td>900</td>
   
 

 </tr>

 <tr>
   
   <td>15</td>
   <td>1020</td>
   <td>2000</td>
   <td>1200</td>
   <td>2450</td>
   <td>1800</td>
   <td>1000</td>
   
 

 </tr>


 <tr>
   
   <td>16</td>
   <td>1088</td>
   <td>2000</td>
   <td>1300</td>
   <td>2450</td>
   <td>1900</td>
   <td>1000</td>
   
 

 </tr>

 <tr>
   
   <td>20</td>
   <td>1360</td>
   <td>2000</td>
   <td>1500</td>
   <td>2450</td>
   <td>2100</td>
   <td>1000</td>
   
 

 </tr>

 <tr>
   
   <td>24</td>
   <td>1632</td>
   <td>2000</td>
   <td>1750</td>
   <td>2500</td>
   <td>2350</td>
   <td>1000</td>
   
 

 </tr>
 

</table>

</body>
</html>








        </div>

       





        
    )
}

export default Table